import type { ReactNode } from "react"
import { WarningIcon } from "@phosphor-icons/react"

import { cn } from "~/utils/helpers"

/** An inline orange warning: a title, a short body, and the actions that resolve it. */
export default function WarningNotice({
  title,
  children,
  actions,
  className,
}: {
  title: ReactNode
  children: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <div
      role="status"
      className={cn(
        "flex flex-wrap items-start gap-x-2 gap-y-3 rounded-lg border border-badge-orange-border bg-badge-orange-bg px-3 py-2.5 text-badge-orange-fg-text",
        className,
      )}
    >
      <WarningIcon size={16} className="mt-0.5 shrink-0" />
      <div className="flex min-w-0 grow basis-64 flex-col gap-0.5">
        <span className="label-sm">{title}</span>
        <span className="max-w-[50ch] paragraph-xs">{children}</span>
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2 self-center">{actions}</div>
      )}
    </div>
  )
}
